import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import CollectionDashboard from './Container/CollectionDashboard/CollectionDashboard';
import PaytmUI from './Container/PaytmUI/PaytmUI';
import PaytmCallback from './Container/PaytmCallback/PaytmCallback';
import StatementOfAccount from './Container/StatementOfAccount/StatementOfAccount';
//import './App.css';

function App() {

  return (
    <BrowserRouter>
      <Route component={CollectionDashboard} path='/collection' exact />
      <Route component={PaytmUI} path='/paytm' exact />
      <Route component={PaytmCallback} path='/paytm/callback' exact />
      <Route component={StatementOfAccount} path='/statement-of-account' exact />
    </BrowserRouter>
  );
}

export default App;
